import api from '../config/api';

export interface UserActivity {
   id: string;
   userId: string;
   actionType: string;
   page: string;
   source: string;
   sessionId: string;
   timestamp: string;

   // Additional fields from comprehensive tracking
   category?: string;
   subcategory?: string;
   description?: string;
   referrer?: string;
   targetId?: string;
   targetType?: string;
   value?: number;
   environment?: string;
   version?: string;
   isAnonymous?: boolean;

   metadata: {
      pagePath?: string;
      pageTitle?: string;
      authMethod?: string;
      userEmail?: string;
      errorCode?: string;
      errorMessage?: string;
      duration?: number;
      fileCount?: number;
      fileTypes?: string[];
      [key: string]: any;
   };

   deviceInfo: {
      userAgent?: string;
      platform?: string;
      screenResolution?: string;
      browserInfo?: string;
      isMobile?: boolean;
      [key: string]: any;
   };

   location?: {
      latitude?: number;
      longitude?: number;
      city?: string;
      country?: string;
      timezone?: string;
   } | null;

   user: {
      firstName: string;
      lastName: string;
      email: string;
      photoURL?: string;
   };
}

export interface ActivityFilters {
   page?: number;
   limit?: number;
   actionType?: string;
   category?: string;
   startDate?: string;
   endDate?: string;
}

export interface ActivityStats {
   totalActivities: number;
   uniqueUsers: number;
   actionTypes: { [key: string]: number };
   pages: { [key: string]: number };
   dailyActivity: { [key: string]: number };
}

export const activitiesService = {
   // Get user activities with filters
   async getActivities(filters: ActivityFilters = {}) {
      const params = new URLSearchParams();

          if (filters.page) params.append('page', filters.page.toString());
    if (filters.limit) params.append('limit', filters.limit.toString());
    if (filters.actionType) params.append('actionType', filters.actionType);
    if (filters.category) params.append('category', filters.category);
    if (filters.startDate) params.append('startDate', filters.startDate);
    if (filters.endDate) params.append('endDate', filters.endDate);

      const response = await api.get(`/activities?${params.toString()}`);
      return response.data;
   },

   // Get activity statistics
   async getActivityStats() {
      const response = await api.get('/activities/stats');
      return response.data;
   },

   // Track new activity
   async trackActivity(activityData: {
      userId: string;
      actionType: string;
      page: string;
      source: string;
      metadata?: any;
      deviceInfo?: any;
      sessionId: string;
   }) {
      const response = await api.post('/activities/track', activityData);
      return response.data;
   },
};

export default activitiesService;
